var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftFrame1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 981 981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#97675e;}.cls-2{fill:#20456e;}.cls-3{fill:#173856;}.cls-4{fill:#639;}.cls-5{fill:#2d120a;}.cls-6{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "frame 1 miroir") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "perso_2_miroir",
    "data-name": "perso 2 miroir"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 489.7,
    cy: 219.5,
    r: 169
  }), /*#__PURE__*/React.createElement("g", {
    id: "frame_1_3",
    "data-name": "frame 1&3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1072.7,1252.5v-203s0-50-66-50-66,40-66,40v213Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1073.2,1252s-12,114-11.29,208.57c12.86,5.54,9.57,81.43,9.57,81.43l-170.57,1.65s-10.39-64.36,51.08-70.55C942.64,1419,939.2,1323,940.2,1252,986.2,1253,1073.2,1252,1073.2,1252Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 940.2,
    y: 1244,
    width: 133,
    height: 8,
    transform: "translate(1496.4 1885) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bras_arri\\xE8re",
    "data-name": "bras arri\\xE8re"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1037.87,1250.43s13.27,74-30,66.51S981.65,1244,981.65,1244Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1050,1060.78s-31.09-79.29-86.08-22.68l4,212.58s43.07,18.85,78,3.72C1049.21,1179.18,1050,1060.78,1050,1060.78Z",
    transform: "translate(-517 -611)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1040.31,1004.55c-8.6-3.4-19.44-5.55-33.11-5.55-66,0-68,40-68,40S954.2,1014,1040.31,1004.55Z",
    transform: "translate(-517 -611)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1046.2,914l10,77.13s157-27.13,134-204.13c-13.94-107.25-110.8-146.53-194-140-26.27,2.06-70.79,18.2-101,41a196,196,0,0,0-49,55l103,42,58,81s27.67-26.15,54-14C1087.2,864,1081.2,918,1046.2,914Z",
    transform: "translate(-517 -611)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "cadre_invisible",
    "data-name": "cadre invisible"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 981,
    height: 981
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftFrame1);
export default __webpack_public_path__ + "static/media/left_frame_1.7ebc3b7c6d1015f084b9200aff51764d.svg";
export { ForwardRef as ReactComponent };